import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';

export function useGeneralArchiveSettings() {
  const {
    tours: {
      AccountingSettings: { General },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: General.Title,
      steps: [
        {
          content: General.Step1.Text,
          placement: 'auto',
          target: '#onlineArchiveTitle',
          title: General.Step1.Title,
          disableBeacon: true,
          link: General.Step1.DetailsLink,
        },
        {
          content: General.Step2.Text,
          placement: 'auto',
          target: '#general',
          title: General.Step2.Title,
          disableBeacon: true,
          link: General.Step2.DetailsLink,
        },
      ],
    }),
    [General],
  );

  return [pageTour];
}
